export default __webpack_public_path__ + "static/media/05_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A3695.f0d824a8.jpg";